import { Dashboard } from '../../pages/Dashboard';
import { Login } from '../../pages/Login';
import { Users } from '../../pages/Users';
import { UserEdit } from '../../pages/Users/components/UserEdit';
import { Companies } from '../../pages/Companies';
import { CompanyEdit } from '../../pages/Companies/components/CompanyEdit';
import { CompanyAnalytics } from '../../pages/Companies/components/CompanyAnalytics';
import { MyCompanies } from '../../pages/MyCompanies';
import { MyCompanyEdit } from '../../pages/MyCompanies/components/MyCompanyEdit';
import { MyCompanyAnalytics } from '../../pages/MyCompanies/components/MyCompanyAnalytics';
import { WcoXmlWebAnalytics } from '../../pages/WcoXmlWebAnalytics';
import { Settings } from '../../pages/Settings';
import { FourZeroFour } from '../../pages/404';
import { FourZeroThree } from '../../pages/403';

import { userRoles } from '../../constants/userRoles';

export const routes = {
  login: { url: '/front/login', component: <Login /> },
  dashboard: {
    url: '/front',
    component: <Dashboard />,
    private: true,
    roles: [userRoles.ADMIN, userRoles.MODERATOR, userRoles.OPERATOR, userRoles.SUPER_USER],
  },
  users: {
    url: '/front/users',
    component: <Users />,
    private: true,
    roles: [userRoles.ADMIN],
  },
  userEdit: {
    url: '/front/users/:userId',
    component: <UserEdit />,
    private: true,
    roles: [userRoles.ADMIN],
  },
  companies: {
    url: '/front/companies',
    component: <Companies />,
    private: true,
    roles: [userRoles.ADMIN, userRoles.MODERATOR, userRoles.SUPER_USER],
  },
  companyEdit: {
    url: '/front/companies/:companyId',
    component: <CompanyEdit />,
    private: true,
    roles: [userRoles.ADMIN, userRoles.MODERATOR, userRoles.SUPER_USER],
  },
  companyAnalytics: {
    url: '/front/companies/:companyId/analytics',
    component: <CompanyAnalytics />,
    private: true,
    roles: [userRoles.ADMIN, userRoles.MODERATOR, userRoles.SUPER_USER],
  },
  myCompanies: {
    url: '/front/my-companies',
    component: <MyCompanies />,
    private: true,
    roles: [userRoles.ADMIN, userRoles.MODERATOR, userRoles.OPERATOR],
  },
  myCompanyEdit: {
    url: '/front/my-companies/:myCompanyId',
    component: <MyCompanyEdit />,
    private: true,
    roles: [userRoles.ADMIN, userRoles.MODERATOR, userRoles.OPERATOR],
  },
  myCompanyAnalytics: {
    url: '/front/my-companies/:myCompanyId/analytics',
    component: <MyCompanyAnalytics />,
    private: true,
    roles: [userRoles.ADMIN, userRoles.MODERATOR, userRoles.OPERATOR],
  },
  companyWcoXmlAnalytics: {
    url: '/front/companies/:companyId/wcoxml-web',
    component: <WcoXmlWebAnalytics />,
    private: true,
    roles: [userRoles.ADMIN, userRoles.MODERATOR, userRoles.OPERATOR, userRoles.SUPER_USER],
  },
  settings: {
    url: '/front/settings',
    component: <Settings />,
    private: true,
    roles: [userRoles.ADMIN],
  },
  403: { url: '/front/403', component: <FourZeroThree /> },
  '*': { url: '/front*', component: <FourZeroFour /> },
};
